import React from 'react';
import {createRoot} from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from "react-redux";
import store from "./store";
import 'bootstrap/dist/js/bootstrap.min';
import {handleResizeObserverError} from './utils/resizeObserverError';

if (process.env.NODE_ENV === 'development') {
    window.addEventListener('error', handleResizeObserverError);
    if (module.hot) {
        module.hot.dispose(() => {
            window.removeEventListener('error', handleResizeObserverError);
        });
    }
}

const root = createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
        <App />
    </Provider>
);

if (module.hot) {
    module.hot.accept()
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
